<div class="xcdrs-dialog">
    <button mat-button mat-icon-button mat-dialog-close class="close-btn">
      <mat-icon class="gray-icon">close</mat-icon>
    </button>
    <div mat-dialog-title>
      <span class="title" [translate]="title"></span>
    </div>
    <div class="search-field-container">
        <xcdrs-search-field class="remove-maxwidth" (search)="onSearchInputChange($event)"></xcdrs-search-field>
    </div>
    <div mat-dialog-content infiniteScroll [infiniteScrollThrottle]="100" [scrollWindow]="false">
      <ul class="organizations-list">
        <ng-container *ngFor="let item of searchedItems">
          <li class="list-item">
            <mat-radio-button [checked]="isSelected(item.id)"  (change)="onRadioBtnChange($event)" [value]="item.id">
            </mat-radio-button>
            <div class="info">
              <span class="org-name">{{item.name}}</span>
            </div>
          </li>
        </ng-container>
      </ul>
      <mat-spinner style="margin: 1.5rem auto" *ngIf="loading"></mat-spinner>
    </div>
    <div mat-dialog-actions>
      <div class="d-flex flex-row flex-grow-1">
        <button (click)="closeDialog()" mat-flat-button class="flex-grow-1" color="primary" [disabled]="loading">
          <span *ngIf="!loading" translate="ExdrCommon.Done"></span>
          <span *ngIf="loading" translate="ExdrCommon.Loading"></span>
        </button>
      </div>
    </div>
</div>